import { type CommandProps,findParentNode } from "@tiptap/core";

import type { ReactionResourceOption } from "../suggestion/suggestion-types";
import {
	encodeResourceSlotToken,
	formatResourceSlotsAttr,
	parseResourceSlotsAttr,
} from "./paragraph-resource-meta";

/**
 * `braceInner` must match `{braceInner}` in the editor for non-`screenField` resources.
 * For `screenField`, the slot is always `<resource.value>:::screenField` (field id).
 * For `advancedTrigger`, the slot is `<resource.triggerName>:::advancedTrigger`.
 */
export function mergeParagraphResourceSlotAfterInsert(
	resource: ReactionResourceOption,
	braceInner: string
) {
	return ({ tr, state }: CommandProps) => {
		const hit = findParentNode((node) => node.type.name === "paragraph")(state.selection);
		if (!hit) {
			return false;
		}

		const slotFirstSegment =
      resource.resourceType === "screenField"
      	? String(resource.value).trim()
      	: resource.resourceType === "advancedTrigger"
      		? String(resource.triggerName ?? resource.label).trim()
      		: braceInner.trim();

		const prev = hit.node.attrs.resourceSlots as string | null;
		const slots = parseResourceSlotsAttr(prev);
		const token = encodeResourceSlotToken(slotFirstSegment, resource.resourceType);
		if (!slots.includes(token)) {
			slots.push(token);
		}

		const nextAttr = slots.length ? formatResourceSlotsAttr(slots) : null;

		tr.setNodeMarkup(hit.pos, undefined, {
			...hit.node.attrs,
			resourceSlots: nextAttr,
		});
		return true;
	};
}
